/* Customilia 顶部抽屉预览 (1:1 复刻插件弹框的出现/消失与内容)
   之前一直在猜插件的实现机制 (position:fixed / 容器选择器...), 都不对。
   新方案: 不猜, 用 MutationObserver 全局监听 body 的 DOM 变化,
   自动发现页面上新增的"弹框层" (任何 position:fixed 的非抽屉节点, 或带遮罩的容器)。
   发现弹框 -> 弹出顶部抽屉; 弹框移除 -> 收起抽屉。
   内容 = .embla__slide.current-slide 里的当前媒体 (img / canvas) */
(function () {
  var DEBUG = true;
  var MIN = 1;
  var MAX = 4;
  var STEP = 0.25;

  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("%c[cmilia]", "color:#7c3aed;font-weight:bold");
    console.log.apply(console, args);
  }

  var CURRENT_SLIDE_SELECTOR = "#artwork-preview .embla__container .embla__slide.current-slide";
  log("脚本已加载, 启动全局 DOM 监听...");

  function describe(el) {
    if (!el) return "null";
    var tag = el.tagName.toLowerCase();
    var id = el.id ? "#" + el.id : "";
    var cls = el.className && typeof el.className === "string" ? "." + el.className.trim().split(/\s+/).join(".") : "";
    return tag + id + cls;
  }

  function describeMedia() {
    var media = findSlideMedia();
    if (!media) return "无媒体";
    if (media instanceof HTMLCanvasElement) {
      return "canvas (" + media.width + "x" + media.height + " 内部, " + media.offsetWidth + "x" + media.offsetHeight + " 显示)";
    }
    if (media instanceof HTMLImageElement) {
      var src = (media.currentSrc || media.src).split("/").pop().split("?")[0];
      return "img (" + src + " " + media.naturalWidth + "x" + media.naturalHeight + ")";
    }
    return describe(media);
  }

  /* 兼容两种商品页的源媒体查找:
     1. 定制类商品: .embla__slide.current-slide 下的 canvas/img
     2. 普通商品: .product__media-item.is-selected (Flickity 切换, 用户主动点缩略图)
                  或 .is-initial-selected (主图区, 初始选中) 下的 img */
  function findSlideMedia() {
    /* 优先: embla 定制类 */
    var emblaSlide = document.querySelector(CURRENT_SLIDE_SELECTOR);
    if (emblaSlide) {
      var m = emblaSlide.querySelector("canvas") || emblaSlide.querySelector("img");
      if (m) return m;
    }
    /* 普通类: 优先取 is-selected 且不带 is-initial-selected 的 (用户主动切换的) */
    var all = document.querySelectorAll(".product__media-item.is-selected");
    var sel = null;
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains("is-initial-selected")) { sel = all[i]; break; }
    }
    /* 兜底: 没找到用户切换的就取主图 is-initial-selected */
    if (!sel) sel = document.querySelector(".product__media-item.is-initial-selected");
    if (sel) {
      var img = sel.querySelector("img");
      if (img) return img;
      var mid = sel.getAttribute("data-media-id") || sel.id;
      if (mid) {
        var target = document.querySelector('[data-media-id="' + mid + '"].product__media img, #' + CSS.escape(mid) + " img");
        if (target) return target;
      }
    }
    return null;
  }

  var drawer = null;
  var mirrorCanvas = null;
  var mirrorImg = null;
  var mirrorCtx = null;
  var plusBtn = null;
  var minusBtn = null;
  var MIN = 1,
    MAX = 4,
    STEP = 0.25;
  var scale = 1;
  var dragX = 0,
    dragY = 0;
  var isDragging = false;
  var dragStartX = 0,
    dragStartY = 0,
    dragBaseX = 0,
    dragBaseY = 0;
  var isOpen = false;
  var rafId = null;
  var currentMedia = null;
  var lastImgSrc = null;
  var currentPopupEl = null; /* 跟踪当前弹框元素, 用于消失检测 */
  var userClosed = false; /* 用户主动点 X/Esc 关闭后锁死, 滚动收回不算 */

  function buildDrawer() {
    drawer = document.createElement("div");
    drawer.className = "cmilia-drawer";
    drawer.setAttribute("aria-hidden", "true");

    var inner = document.createElement("div");
    inner.className = "cmilia-drawer__inner";

    mirrorCanvas = document.createElement("canvas");
    mirrorCanvas.className = "cmilia-drawer__canvas";

    mirrorImg = document.createElement("img");
    mirrorImg.className = "cmilia-drawer__img";
    mirrorImg.alt = "";

    var close = document.createElement("button");
    close.type = "button";
    close.className = "cmilia-drawer__close";
    close.setAttribute("aria-label", "Close preview");
    close.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';

    var zoom = document.createElement("div");
    zoom.className = "cmilia-drawer__zoom";
    zoom.setAttribute("role", "group");
    zoom.setAttribute("aria-label", "Zoom preview");

    plusBtn = document.createElement("button");
    plusBtn.type = "button";
    plusBtn.className = "cmilia-drawer__zoom-btn";
    plusBtn.setAttribute("aria-label", "Zoom in");
    plusBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';

    minusBtn = document.createElement("button");
    minusBtn.type = "button";
    minusBtn.className = "cmilia-drawer__zoom-btn";
    minusBtn.setAttribute("aria-label", "Zoom out");
    minusBtn.disabled = true;
    minusBtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';

    zoom.appendChild(plusBtn);
    zoom.appendChild(minusBtn);
    inner.appendChild(mirrorCanvas);
    inner.appendChild(mirrorImg);
    inner.appendChild(close);
    inner.appendChild(zoom);
    drawer.appendChild(inner);
    document.body.appendChild(drawer);
    log("抽屉 DOM 已创建");

    close.addEventListener("click", userCloseDrawer);
    plusBtn.addEventListener("click", function () {
      if (scale < MAX) {
        scale = Math.min(MAX, scale + STEP);
        applyScale();
      }
    });
    minusBtn.addEventListener("click", function () {
      if (scale > MIN) {
        scale = Math.max(MIN, scale - STEP);
        applyScale();
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") userCloseDrawer();
    });

    /* 拖拽平移: 监听在 canvas 和 img 两个媒体上, 避免 inner 空白区误触发穿透到底层页面 */
    function getActiveTarget() {
      return currentMedia === "img" ? mirrorImg : mirrorCanvas;
    }
    function onPointerDown(e) {
      if (e.target.closest(".cmilia-drawer__close, .cmilia-drawer__zoom, .cmilia-drawer__zoom-btn")) return;
      if (scale <= MIN) return; /* 未放大时不能拖 */
      e.preventDefault();
      isDragging = true;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragBaseX = dragX;
      dragBaseY = dragY;
      e.target.setPointerCapture(e.pointerId);
      e.target.style.cursor = "grabbing";
    }
    function onPointerMove(e) {
      if (!isDragging) return;
      e.preventDefault();
      dragX = dragBaseX + (e.clientX - dragStartX);
      dragY = dragBaseY + (e.clientY - dragStartY);
      applyScale();
    }
    function onPointerEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      try {
        e.target.releasePointerCapture(e.pointerId);
      } catch (_) {}
      e.target.style.cursor = "grab";
    }
    mirrorCanvas.addEventListener("pointerdown", onPointerDown);
    mirrorCanvas.addEventListener("pointermove", onPointerMove);
    mirrorCanvas.addEventListener("pointerup", onPointerEnd);
    mirrorCanvas.addEventListener("pointercancel", onPointerEnd);
    mirrorImg.addEventListener("pointerdown", onPointerDown);
    mirrorImg.addEventListener("pointermove", onPointerMove);
    mirrorImg.addEventListener("pointerup", onPointerEnd);
    mirrorImg.addEventListener("pointercancel", onPointerEnd);
  }

  function applyScale() {
    var target = currentMedia === "img" ? mirrorImg : mirrorCanvas;
    /* 合并 scale + translate, 避免覆盖拖动产生的位移 */
    target.style.transform = "translate(" + dragX + "px, " + dragY + "px) scale(" + scale + ")";
    minusBtn.disabled = scale <= MIN;
    plusBtn.disabled = scale >= MAX;
  }

  function syncLoop() {
    if (!isOpen) return;
    var media = findSlideMedia();
    if (media instanceof HTMLCanvasElement) {
      if (currentMedia !== "canvas") {
        currentMedia = "canvas";
        mirrorCanvas.style.display = "block";
        mirrorImg.style.display = "none";
        lastImgSrc = null;
      }
      if (media.width > 0) {
        if (mirrorCanvas.width !== media.width || mirrorCanvas.height !== media.height) {
          mirrorCanvas.width = media.width;
          mirrorCanvas.height = media.height;
        }
        mirrorCtx.clearRect(0, 0, mirrorCanvas.width, mirrorCanvas.height);
        try {
          mirrorCtx.drawImage(media, 0, 0);
        } catch (e) {
          /* 源画布被跨域污染时, 镜像画布保持空白 */
        }
      }
    } else if (media instanceof HTMLImageElement) {
      var src = media.currentSrc || media.src || media.getAttribute("data-src") || media.getAttribute("data-original") || media.getAttribute("data-lazy-src") || media.getAttribute("data-srcset");
      if (currentMedia !== "img" || lastImgSrc !== src) {
        currentMedia = "img";
        lastImgSrc = src;
        mirrorCanvas.style.display = "none";
        mirrorImg.style.display = "block";
        /* 强制 cache-busting + 重新触发 onload, 避免浏览器复用旧 src 的失败状态 */
        mirrorImg.src = src ? src : "";
      }
    }
    rafId = requestAnimationFrame(syncLoop);
  }

  function openDrawer(triggerEl) {
    log("弹出抽屉 (触发元素:", describe(triggerEl), ")", "| 当前幻灯片内容:", describeMedia());
    if (!drawer) buildDrawer();
    isOpen = true;
    scale = 1;
    dragX = 0;
    dragY = 0;
    isDragging = false;
    currentMedia = null;
    lastImgSrc = null;
    mirrorCanvas.style.display = "none";
    mirrorImg.style.display = "none";
    applyScale();
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cmilia-drawer-open");
    mirrorCtx = mirrorCanvas.getContext("2d");
    cancelAnimationFrame(rafId);
    syncLoop();
  }

  /* 暴露调试接口 */
  window.__cmiliaDebug = function () {
    return {
      isOpen: isOpen,
      drawerExists: !!drawer,
      hasIsOpen: drawer ? drawer.classList.contains("is-open") : null,
      bodyClass: document.body.className,
      popup: findPopup() ? "yes" : "no",
    };
  };

  function closeDrawer() {
    if (!drawer || !isOpen) return;
    log("收起抽屉 (插件状态: 弹框 DOM 已移除/隐藏)");
    isOpen = false;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cmilia-drawer-open");
    cancelAnimationFrame(rafId);
  }

  /* 用户主动关闭 (X / Esc): 锁死, 之后无论滚动都不再弹 */
  function userCloseDrawer() {
    if (!drawer || !isOpen) return;
    log("收起抽屉 (用户主动关闭, 锁死到刷新)");
    userClosed = true;
    closeDrawer();
  }

  /* ===== 抽屉显示判定: 与原插件弹框 1:1 同步 =====
     弹框节点 = .template-product .product__media.cm-sticky-media。
     默认态: position: static (被 sticky-media 规则拉到固定位置但非弹框) -> 抽屉隐藏
     弹框态: 被插件改 position: fixed + display: block + 视口居中 -> 抽屉显示
     判定的"硬指标"是该元素在当前视口内可见, 且包含可绘制的媒体。 */
  /* ===== 抽屉显示规则 =====
     1. 仅移动端 (≤999px) 触发, PC 端不显示抽屉
     2. 抽屉出现 = .cm-sticky-media class 存在 (这是 sticky-media 规则在弹框态/预览态才加的 class)
     3. 抽屉内容兼容两种商品页:
        - 定制类: .embla__slide.current-slide 下的 canvas/img
        - 普通类: .product__media-item.is-selected (Flickity 切换) 或 .is-initial-selected (主图) 下的 img */
  var IS_MOBILE = function () {
    return window.matchMedia("(max-width: 999px)").matches;
  };
  var STICKY_SELECTOR = "product-media.product__media.customall_product.cm-sticky-media, product-media.product__media.cm-sticky-media";
  function findPopup() {
    if (!IS_MOBILE()) return null; /* PC 端不弹 */
    var el = document.querySelector(STICKY_SELECTOR);
    if (!el) return null;
    /* .cm-sticky-media class 存在就是弹框态 (sticky-media 规则在弹框态/预览态才加这个 class) */
    return el;
  }

  function tick() {
    if (userClosed) return; /* 用户主动关闭后, 直到刷新都不再弹 */
    var popup = findPopup();
    if (popup) {
      if (!isOpen) {
        currentPopupEl = popup;
        openDrawer(popup);
      } else {
        /* 抽屉已开, 但源 media 节点可能换了 (Flickity 切图) -> 重置同步状态让 syncLoop 重新加载 */
        currentMedia = null;
        lastImgSrc = null;
      }
    } else {
      if (isOpen) {
        currentPopupEl = null;
        closeDrawer();
        /* 同时清掉任何缩放/拖动残留, 防止下次 openDrawer 状态错位 */
        scale = 1;
        dragX = 0;
        dragY = 0;
        isDragging = false;
        if (mirrorImg) {
          mirrorImg.style.transform = "";
        }
        if (mirrorCanvas) {
          mirrorCanvas.style.transform = "";
        }
      }
    }
  }

  /* MutationObserver 监听 body 子树, 一旦插件加入新节点立即检查 */
  var observer = new MutationObserver(function (mutations) {
    tick();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class"] });

  /* 兜底: 每 500ms 再检查一次, 防止某些改动不触发 mutation */
  setInterval(tick, 500);

  /* 启动 3 秒后输出诊断 */
  setTimeout(function () {
    log("--- 3秒诊断 ---");
    log("当前幻灯片:", describe(document.querySelector(CURRENT_SLIDE_SELECTOR)));
    log("当前幻灯片内容:", describeMedia());
    var p = findPopup();
    log("原弹框节点:", p ? describe(p) : "null");
    /* 列出 window 上所有 Customilia 相关全局, 寻找暴露的弹框控制 API */
    var globals = Object.keys(window).filter((k) => /custom|cx|kiara|personali/i.test(k));
    log("Customilia 相关 window 全局:", globals.length ? globals.join(", ") : "(无)");
    /* 列出页面上所有 shadowRoot host, 找 web component 入口 */
    var hosts = [];
    document.querySelectorAll("*").forEach(function (n) {
      if (n.shadowRoot) hosts.push(n.tagName.toLowerCase() + (n.id ? "#" + n.id : ""));
    });
    log("shadowRoot host:", hosts.length ? hosts.join(", ") : "(无)");
  }, 3000);
})();
